import { render } from "./addtype.vue?vue&type=template&id=789cdd2f&scoped=true"
import script from "./addtype.vue?vue&type=script&lang=js"
export * from "./addtype.vue?vue&type=script&lang=js"

import "./addtype.vue?vue&type=style&index=0&id=789cdd2f&scoped=true&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789cdd2f"]])

export default __exports__